module.exports = __webpack_public_path__ + "static/media/rate.026a793c.svg";